import Navigation from "./navigation/index"
import Menu from "./components/menu"
import PictureFull from "./components/picture-full/index"
import Datas from "./components/datas"
import Presse from "./components/presse"
import Media from "./components/media"
import Clients from "./components/clients"
import CookieBanner from "./components/cookie-banner"

export default class App {
  components = [];
  constructor() {
    this.menu = new Menu({ el: document.body })
    new Navigation({
      menu: this.menu,
      callback: (container) => {
        this.bindComponents(container)
      },
      leaveCallback: (container) => {
        this.unbindComponents()
      }
    })

    this.bindComponents(document.body)

    const $cookieBanner = document.body.querySelector(".wp-block-omnicom-site-cookie-banner")
    this.components.push(new CookieBanner({el: $cookieBanner}))
  }
  bindComponents(container) {
    const scrollerContainer = container.tagName === 'BODY' ? container.querySelector(`[data-barba="container"]`) : container

    const $pictureFull = container.querySelector(".wp-block-omnicom-picture-full")
    if ($pictureFull) this.components.push(new PictureFull({el:$pictureFull, container: scrollerContainer}))

    const $datas = container.querySelectorAll(".wp-block-omnicom-datas")
    $datas.forEach((el) => {
      this.components.push(new Datas({el}))
    })

    const $presse = container.querySelectorAll(".wp-block-omnicom-presse")
    $presse.forEach((el) => {
      this.components.push(new Presse({el}))
    })

    const $media = container.querySelectorAll(".wp-block-omnicom-media")
    $media.forEach((el) => {
      this.components.push(new Media({el}))
    })

    const $clients = container.querySelectorAll(".wp-block-omnicom-clients")
    $clients.forEach((el) => {
      this.components.push(new Clients({el}))
    })
  }
  unbindComponents() {
      this.components.forEach(component => {
        if ("dispose" in component) component.dispose()
      })

  }
}